import React from 'react';
import { Truck, Store } from 'lucide-react';
export function ServiceModes() {
  return <section className="py-24 bg-brand-charcoal relative z-30 -mt-8 rounded-t-[3rem]" data-id="element-180">
      <div className="container mx-auto px-6 md:px-12" data-id="element-181">
        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto" data-id="element-182">
          {/* Mobile Grooming Card */}
          <div className="group bg-brand-dark p-8 md:p-12 rounded-3xl border border-brand-orange/20 hover:border-brand-orange transition-all duration-500 hover:-translate-y-2 hover:box-glow flex flex-col h-full" data-id="element-183">
            <div className="w-16 h-16 bg-brand-orange/10 rounded-2xl flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-500" data-id="element-184">
              <Truck className="text-brand-orange" size={32} data-id="element-185" />
            </div>
            <h3 className="text-3xl font-heading text-brand-light mb-4" data-id="element-186">
              We Come to Your Driveway
            </h3>
            <p className="text-brand-light/70 mb-8 flex-grow leading-relaxed" data-id="element-187">
              Skip the drive. We bring the luxury spa experience right to your
              home. One-on-one, stress-free, and completely cage-free.
            </p>
            <a href="#book" className="inline-flex items-center justify-center text-brand-orange font-semibold hover:text-orange-400 transition-colors group/link" data-id="element-188">
              Request a Quote
              <span className="ml-2 transform group-hover/link:translate-x-1 transition-transform" data-id="element-189">
                →
              </span>
            </a>
          </div>

          {/* Salon Card */}
          <div className="group bg-brand-dark p-8 md:p-12 rounded-3xl border border-brand-pink/20 hover:border-brand-pink transition-all duration-500 hover:-translate-y-2 hover:box-glow-pink flex flex-col h-full" data-id="element-190">
            <div className="w-16 h-16 bg-brand-pink/10 rounded-2xl flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-500" data-id="element-191">
              <Store className="text-brand-pink" size={32} data-id="element-192" />
            </div>
            <h3 className="text-3xl font-heading text-brand-light mb-4" data-id="element-193">
              Visit Our New Goodyear Salon
            </h3>
            <p className="text-brand-light/70 mb-8 flex-grow leading-relaxed" data-id="element-194">
              Prefer to drop off? Our brand-new salon in Goodyear, AZ offers the
              same premium, cage-free grooming in a relaxed and welcoming space.
            </p>
            <a href="#contact" className="inline-flex items-center justify-center text-brand-pink font-semibold hover:text-pink-400 transition-colors group/link" data-id="element-195">
              Get Directions
              <span className="ml-2 transform group-hover/link:translate-x-1 transition-transform" data-id="element-196">
                →
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>;
}